import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import type { IconButtonProps } from "@/types";
import { Icon } from "@/components/common/display";


/**
 * A generic icon button.
 */
const __default__ = {
  name: "IconButton",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tooltip: {},
    tooltipDelay: {},
    iconId: {},
    fab: { type: Boolean },
    rotate: {},
    icon: {},
    disabled: { type: Boolean },
    color: {},
    small: { type: Boolean },
    large: { type: Boolean },
    dataCy: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const size = computed(() => {
  if (props.small) {
    return "sm";
  } else if (props.large) {
    return "lg";
  } else {
    return "";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    color: props.color,
    fab: props.fab,
    disable: props.disabled,
    size: size.value,
    "data-cy": props.dataCy,
    flat: !props.fab,
    round: !props.fab,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Icon), {
        id: props.iconId,
        variant: props.icon,
        rotate: props.rotate
      }, null, 8, ["id", "variant", "rotate"]),
      _createVNode(_component_q_tooltip, {
        delay: props.tooltipDelay || 200
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.tooltip), 1)
        ]),
        _: 1
      }, 8, ["delay"]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["color", "fab", "disable", "size", "data-cy", "flat", "round"]))
}
}

})